//LocalStorageWrapper = function(){ };
var LocalStorageService = {

  getItem: function ls_getItem(key) {
    try {
      return localStorage.getItem(key);
    }
    catch(e){}
  },

  setItem: function ls_setItem(key, value) {
    try {
      return localStorage.setItem(key, value);
    }
    catch(e){}
  },

  removeItem: function ls_removeItem(key) {
    return localStorage.removeItem(key);
  },

  clear: function ls_clear(){
    try {
      localStorage.clear();
    }
    catch(e){}
  }

};

module.exports = LocalStorageService;